import OnboardingVideos from '@components/OnboardingVideosComponent';
import PageWithoutTitle from '@components/PageWithoutTitle';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Modal } from 'antd';
import React from 'react';

import { LocalStorageKeys } from './App';

const homeBackground = require('@src/images/home.png')
const start = require('@src/images/onboarding-start.png')

interface StateType {
	startOnboardingModal: boolean;
	visibleOnboardingModal: boolean;
	firstAccess: boolean;
}

export default class Home extends React.Component<StateType, any> {
	private firstAccess: string;
	constructor(props: any) {
		super(props)
		this.firstAccess = String(localStorage.getItem(LocalStorageKeys.FIRSTACCESS))
		this.state = {
			startOnboardingModal: this.firstAccess === 'null' ? true : false,
			visibleOnboardingModal: false,
			firstAccess: false
		}
	}
	componentDidMount = async () => {
		console.log('firstacess', this.firstAccess)
	}

	toggleWelcomeModal = async () => {
		this.setState({ startOnboardingModal: !this.state.startOnboardingModal })
		localStorage.setItem('firstaccess', 'true')
	}

	toggleOnboardingModal = async () => {
		this.setState({
			visibleOnboardingModal: !this.state.visibleOnboardingModal,
			startOnboardingModal: false,
		})
		localStorage.setItem('firstaccess', 'true')
	}

	render() {
		return (
			<PageWithoutTitle>
				<Wrapper>
					<img className='img-style' src={homeBackground}></img>
					<div className='home-style'>
						<h1 className='title-style'>{I18n.l('home.welcome')}</h1>
						<h1 className='title-style'> {I18n.l('home.intheWorld')}</h1>
						<h4 className='subtitle-style'>{I18n.l('home.description')}</h4>
					</div>
					<Modal
						visible={this.state.startOnboardingModal}
						footer={false}
						width={'80vw'}
						closable={false}
					>
						<ModalContent>
							<img className='align-item-center' src={start}></img>
							<h1 className='title-start'>{I18n.l('onboarding.title')}</h1>
							<h4 className='subtitle-start'> {I18n.l('onboarding.subtitle')}</h4>
							<div className='buttons-style'>
								<Button onClick={this.toggleWelcomeModal} ghost style={{ marginRight: '10px' }} type="primary">{I18n.l('onboarding.seeAfter')}</Button>
								<Button onClick={this.toggleOnboardingModal} type="primary">{I18n.l('onboarding.start')}</Button>
							</div>
						</ModalContent>
					</Modal>
					<OnboardingVideos visibleOnboarding={this.state.visibleOnboardingModal} toggleOnboardingModal={() => this.toggleOnboardingModal} />
				</Wrapper>
			</PageWithoutTitle>
		);
	}
}

const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
	
		.img-style {
			position: absolute;
			max-width: 100%;
			max-height: 70%;
			right: 0;
		}


		.home-style {
			position: absolute;
			top: 30%;
    	padding-left: 3%;
		}
		.title-style {
			font-family: Montserrat;
			font-style: normal;
			font-weight: 800;
			font-size: 60px;
			color: #335D7C;
		}
		.subtitle-style {
			width: 54%;
			font-family: Montserrat;
			font-style: normal;
			font-weight: 600;
			font-size: 22px;
			color: #6A8CA5;
		}
`;
const ModalContent = styled.div`
			.align-item-center{
				padding-top: 1rem;
				display: block;
				margin-left: auto;
				margin-right: auto;
				width: 50%;
		}
			.title-start {
				font-family: Montserrat;
				font-style: normal;
				font-weight: 800;
				font-size: 2vw;
				text-align: center;
				color: #335D7C;
			}
			.subtitle-start {
				font-family: Montserrat;
				font-style: normal;
				font-weight: 600;
				font-size: 1vw;;
				text-align: center;
				color: #6A8CA5;
				display: block;
				margin-left: auto;
				margin-right: auto;
				padding-bottom: 1rem;
				width: 50%;
			}
			.buttons-style {
				text-align: center;
				display: block;
				margin-left: auto;
				margin-right: auto;
				width: 50%;
			}
`;

